'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {preventStateReload} from '../infra/annotations';
import {JournalsService} from '../journals/journals.service';
import {getSearchScopesMap, getScopeList} from '../appConfig/appConfigForward';
import {NewspapersService} from '../newspapers/newspapers.service';
import {ConfigurationUtil} from "./configurationUtil.service";

const flatten = require('lodash/flatten');
const remove = require('lodash/remove');
const find= require('lodash/find');

@Injectable()
export class SearchUtil {

	//private $location:angular.ILocationService;

	/* private members */
	private deepLinksField:any;
	private parameterName:any;

	constructor(@Inject('$stateParams') private $stateParams,
				@Inject('$location') private $location: ng.ILocationService,
				private journalsService: JournalsService,
                private newspapersService : NewspapersService,
				private configurationUtil: ConfigurationUtil){

		/* private members */
		this.deepLinksField = {
			'query'  				: (val) => this.getSearchValue(val),
			'scope'  				: (val) => val,
			'sortby' 				: (val) => val
		};
		this.parameterName = {'query':'query',
			'scope':'search_scope',
			'sortby':'sortby'
		};
	}

     public getValidScope(scope) {
        if (!find(getScopeList(), (cur)=>cur['scope-id']===scope)) {
        	if (this.$location.path()!=="/dbsearch" && this.$location.search()['search_scope'] && this.$location.search()['search_scope'] === scope){
				this.deleteSearchScopeParamOnUrl();
			}
           return;
        } 
        
        return scope;
    }

    @preventStateReload
    private deleteSearchScopeParamOnUrl(){
		this.$location.search('search_scope',null);
	}
    
	getSearchValue(query) {
		if (!query) {
			return '';
		}
		if (Array.isArray(query)) {
			return query;
		}
		let queryArray = query.split(',');
		/* remove field - first element in array
		 * remove operator - second element in array
		 * We only need the value
		 *
		 * e.g
		 * any,contains,water -> water
		 * creator,exact,John -> John
		 */
		for (let i=0;i<2;i++) {
			queryArray.shift();
		}
		return queryArray.join(',');
	}

	get urlParamScope() {
        if (this.newspapersService.isNewspapersSearch() && this.newspapersService.scopes.indexOf(this.$stateParams.search_scope) !== -1) {
			return this.$stateParams.search_scope;
		}
        let scope = this.getValidScope(this.$stateParams.search_scope);
		if (scope){
			return scope;
		}
		return this.getScopeFromTab();
	}

	public getDeepLinkJournalSearchScope() {
		if(this.$stateParams.tab === 'jsearch_slot' && !this.$stateParams.databases)
			return 'jsearch_scope'
	}

	getScopeFromTab() {
		let tab = this.$stateParams.tab;
		if (tab) {
			let scope = getSearchScopesMap()[tab];
			if (scope) {
				return scope[0]['scope-id'];
			}
		}
	}

	get urlParamTab() {
		return this.$stateParams.tab;
	}

	removeAllFacetsFromURL(){
		this.$location.search('facet',[])
		this.$location.search('pfilter', []);
		this.$location.search('mode', []);
	}

   	private filterEmpty(scope) {
		return scope;
	}

	updateLocationBar(args) {
		//let advanced = this.parseArgs(args);
		if (args.mode && args.mode === 'advanced' && args.query) {
			this.parseArgs(args);
		}
		else{
			let keys = Object.keys(this.deepLinksField);
			keys.forEach((f) => {
				if (f in args) {
					if (this.deepLinksField[f](args[f])) {
						this.$location.search(this.parameterName[f], args[f]);
					}
				}
			});
		}

	}


	parseArgs(args) {
		let query = args.query;
		let queryArr = query.split(';');
		let queryA = queryArr.map((query) => { if (!query.match('(facet_|dr_s|dr_e).*,exact,.*,AND')) {return query};
		}).filter(this.filterEmpty);
		let pfilter = queryArr.map((query) => { if (query.match('(facet_|dr_s|dr_e).*,exact,.*,AND')) {return query.replace('facet_','')};
		}).filter(this.filterEmpty);
		this.updateUrlForAdvanced(args,queryA,pfilter);
	}

	@preventStateReload
	private updateUrlForAdvanced(args,queryA,pfilter) {
		this.$location.search('mode', 'advanced');
		this.$location.search('query', queryA);
		this.$location.search('pfilter', pfilter);
		if (args.scope) {
			this.$location.search('search_scope', args.scope);
		}
		if (args.sortby) {
			this.$location.search('sortby', args.sortby);
		}
		if (args.tab) {
			this.$location.search('tab', args.tab);
		}
		if (args.facet) {
			this.$location.search('facet', args.facet);
		}
	}



}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/searchUtil.service.ts